import UerTabs from "./userTabs";

export default UerTabs;